import { Component, inject, OnInit } from '@angular/core';
import { DomSanitizer, Meta, SafeHtml, Title } from "@angular/platform-browser";
import { NgbAccordionModule } from "@ng-bootstrap/ng-bootstrap";
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-members',
  imports: [NgbAccordionModule],
  templateUrl: './members.component.html',
  styleUrl: './members.component.scss'
})
export class MembersComponent implements OnInit {
  private meta = inject(Meta);
  private title = inject(Title);
  faq = [
    {
      count: 1,
      question: 'What do I do if there is a problem with my order?',
      answer: '<p>If you encounter any problems with your order, please email us at info@phillyfoodworks.com, and we will address them as soon as possible (we aim to answer emails within 48 hours). If possible, include a photo of the unsatisfactory item to help us address the issue with our teams and producers.</p>' +
        '<p>If you have a distribution emergency (i.e., you received the wrong share or are unable to receive an order that is on the way), email us at info@phillyfoodworks.com or call our emergency phone at (267) 307-7931.</p>'
    },
    {
      count: 2,
      question: 'How do I customize my customizable bundles?',
      answer: '<p>Please add all your shares to your cart by 9 AM on the Friday before your scheduled delivery.</p> <p>To access your shopping cart, click the shopping cart icon in the top right corner of the screen when logged into your account.</p>' +
        '<img class="img-fluid" src="assets/images/faq/members/img-2-1.png" /><hr class="is-thick">' +
        '<p>In your shopping cart you will see a list of all of your subscriptions.</p>' +
        '<ol class="faq-ol">' +
        '<li>If you would like to edit the contents of one of your customizable bundles click the “edit bundle” hyper link</li>' +
        '<li>You can remove the items by clicking the small trashcan next to the items price on the right hand side of your screen.</li>' +
        '<li>And increase the quantities by using the quantity drop down selector.</li>' +
        '</ol>' +
        '<img class="img-fluid" src="assets/images/faq/members/img-2-2-temp.png" /><hr class="is-thick">' +
        '<p>Once you have removed items you do not want and increased the quantity of any items you want more of, you must click save and then the “update order” button on the right hand side.</p>' +
        '<img class="img-fluid" src="assets/images/faq/members/img-2-4.png" /><hr class="is-thick">' +
        '<p>You can then navigate to the general market and add anything you would like to your order. Note that you are only charged for the items in your bundle for which you keep. If you remove an item from your bundle you will not be charged. Your cart value will update once you save.</p>'
    },
    {
      count: 3,
      question: 'How do I cancel or update the frequency of my shares?',
      answer: '<p>Your shares will be delivered regularly until you cancel or pause them. To view all upcoming deliveries, go to the "subscriptions" page in your account.\n</p>' +
        '<img class="img-fluid" src="assets/images/faq/members/img-3-1.png" /><hr class="is-thick">' +
        '<p>From this page, you can update the frequency or skip an upcoming delivery. To pause all your subscriptions for an extended period, use the green "pause subscription" button in the upper right corner.</p>' +
        '<img class="img-fluid" src="assets/images/faq/members/img-3-2.png" /><hr class="is-thick">' +
        '<p>You’ll receive an email two days before delivery to notify you of any upcoming subscriptions. If you have questions about your order, please email us at <a href="mailto: info@phillyfoodworks.com">info@phillyfoodworks.com</a>.</p>'
    },
    {
      count: 4,
      question: 'How do I cancel my membership?',
      answer: '<p>To remove all your information and cancel your Philly Foodworks membership, complete  <a href="https://www.surveymonkey.com/r/pfwexitsurvey">THIS FORM</a> in its entirety and email us to confirm.</p>'
    },
    {
      count: 5,
      question: 'Can I return my packaging to be reused?',
      answer: '<p>We accept returns of wax boxes, insulated silver cold sleeves, ice packs, plastic clamshells, Oasis Creamery glass milk bottles, Fishtown Pickle Project pickle jars, and Funky Fresh Ferments kombucha bottles. Please leave them outside on the day of your next delivery and our drivers will pick them up. At the warehouse we will sort and sanitize the items to reuse what is in good condition.</p>' +
        '<p>We always appreciate packaging returns as part of our zero waste packaging initiative!</p>'
    },
    {
      count: 6,
      question: 'What if I need to cancel my order after my designated shopping cut-off time?\n',
      answer: '<p>Due to our purchasing and packing operations, processing a late cancellation creates extra paperwork and restocking time.' +
        'Depending on the item and timing of cancellation,  we might end up losing the product contained in your order. In the event of an emergency, please email <a href="mailto: info@phillyfoodworks.com">info@phillyfoodworks.com</a> and we will do our best to accommodate.' +
        'We charge a $5 to $10 late-cancellation fee to help cover some of our product losses and additional packing time costs.</p>'
    },
    {
      count: 7,
      question: 'How do I view my account balance, past orders, payments due etc?',
      answer: '<p>To view your account balance, log in to your account, then navigate to the “orders and billing “page.</p>' +
        '<img class="img-fluid" src="assets/images/faq/members/img-7-1.png" />' +
        '<p>Any credits on your account will appear in the green box at the top of your account.</p>' +
        '<img class="img-fluid" src="assets/images/faq/members/img-7-2.png" />' +
        '<p>You will then see a list of your orders below with their payment status. You can click the “orders details” hyperlink for a full list of your purchases as well as chose to add the same order back to your account.</p>' +
        '<img class="img-fluid" src="assets/images/faq/members/img-7-2.png" />'
    },
    {
      count: 8,
      question: 'How do I update my personal information, delivery address, or credit card information?',
      answer: '<p>To update your personal information or delivery address, log in and go to the "profile" section of your account. There, you can make any necessary changes.</p>' +
        '<img class="img-fluid" src="assets/images/faq/members/img-8-1.png" />' +
        '<p>When changing your delivery address, please confirm your new delivery day and timeslot to save your updates.</p>' +
        '<img class="img-fluid" src="assets/images/faq/members/img-8-2.png" />' +
        '<p>We do not deliver to every neighborhood every day, so changing your delivery address might affect your delivery schedule. If you have an order in the system when you make this change, please note the adjustment.</p>' +
        '<p>To update your payment information, go to the "payment method" section of your account.\n</p>'
    },
    {
      count: 9,
      question: 'Why does product availability change weekly?',
      answer: '<p>This is largely due to our local sourcing methods. Unlike most large retailers, we work with small, local producers. This means product availability changes with the seasons and weather. For example, a hot weekend might cause broccoli to go to seed, or an early frost could wipe out the late-season tomato crop.</p>' +
        '<p>Availability and restocking frequency also depend on our producers\' capacities. If you\'re curious about when something will be back in stock, please email us, and we\'ll give you our best estimate.</p>'
    },
    {
      count: 10,
      question: 'Do you send delivery arrival updates on the day of delivery?',
      answer: '<p>When our driver leaves the warehouse you will receive a text message notifying you of your estimated time of delivery and a link you can click to stay updated with your driver’s progress. You will then receive another text message when our driver is on our way to your house and another one once your delivery is complete.</p>'
    },
    {
      count: 11,
      question: 'How do I update my delivery day or delivery window?',
      answer: '<p>Navigate to the “Deliveries” section of your profile. There at the bottom of the screen, you have the ability to update your delivery day and delivery window for the current delivery or for all deliveries moving forward.</p>'
    }

  ];

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.setUpSEOTags();
  }

  private setUpSEOTags() {
    const { baseTitle, baseURL, type } = environment.config.seo;
    const url = 'pages/faq/members'
    const component = 'Members'
    const title = `${component} | ${baseTitle}`;

    // Page title
    this.title.setTitle(title);

    // Open Graph for social networks:
    this.meta.addTag({ property: 'og:title', content: title });
    this.meta.addTag({ property: 'og:url', content: `${baseURL}${url}` });
    this.meta.addTag({ property: 'og:type', content: type });
  }

  sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
